import { useGetAllformsQuery } from "../Redux/service/Forms/Form";

export const useLocalForms = () => {
  const {
    data: allForms,
    isFetching,
    refetch,
  } = useGetAllformsQuery(
    {
      page: 1,
      limit: 10000,
      isActive: "true",
    },
    { refetchOnMountOrArgChange: true }
  );
  const forms = allForms?.data || [];

  const options = forms.map((form) => ({
    label: form.name,
    value: form.id,
    searchLabel: form.name,
  }));

  return { forms, options, isFetching, refetch };
};
